export interface User {
  accountType: AccountType;
  accountSubType?: AccountSubType;
  email: string;
  first: string;
  forcePwChange: boolean;
  id: number;
  last: string;
  token: string;
}

export const UserSubType = {
  DEFAULT: 'DEFAULT',
  PERFORMANCE_MGM: 'PERFORMANCE_MGM',
} as const;

export type AccountSubType = (typeof UserSubType)[keyof typeof UserSubType];

export enum AccountType {
  NONE = 'NONE',
  DEALER = 'DEALER',
  AFFILIATE = 'AFFILIATE',
  DEMO = 'DEMO',
  RESELLER = 'RESELLER',
  POTENTIALDEALER = 'POTENTIALDEALER',
  ENTERPRISE = 'ENTERPRISE',
  FREETRIAL = 'FREETRIAL',
  BROWSEREXTENSION = 'BROWSEREXTENSION',
  BROWSEREXTENSIONDEMO = 'BROWSEREXTENSIONDEMO',
  OWNER = 'OWNER',
}
